var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Checkbox, Input } from '@paysera/ui';
import FormTooltip from '@modules/borrower/components/solvencyDeclaration/FormTooltip';
import RadioCardField from '@modules/borrower/components/solvencyDeclaration/RadioCardField';
import RadioField from '@modules/borrower/components/solvencyDeclaration/RadioField';
import SelectMultipleField from '@modules/borrower/components/solvencyDeclaration/SelectMultipleField';
import { preventNegativeNumberKeyDown } from './preventNegativeNumberKeyDown';
export const renderField = (form, field, t, validateField, labelOverride) => {
    var _a;
    const parsedValues = (_a = field.values) === null || _a === void 0 ? void 0 : _a.map((obj) => {
        const [key, value] = Object.entries(obj)[0];
        return { value: key, label: value };
    }).filter((option) => option.value !== '');
    const _b = form.register(field.name), { onChange: registerOnChange } = _b, registerProps = __rest(_b, ["onChange"]);
    const handleChange = (event) => {
        registerOnChange(event);
        validateField();
    };
    const label = field.label || labelOverride || '';
    switch (field.type) {
        case 'select': {
            const shouldRenderAsCards = (parsedValues === null || parsedValues === void 0 ? void 0 : parsedValues.length) === 2 &&
                parsedValues.some((o) => o.value === 'yes') &&
                parsedValues.some((o) => o.value === 'no');
            const FieldComponent = shouldRenderAsCards ? RadioCardField : RadioField;
            return (<FieldComponent name={field.name} label={label} options={parsedValues !== null && parsedValues !== void 0 ? parsedValues : []} control={form.control} onAfterChange={validateField}/>);
        }
        case 'checkbox': {
            return (<>
                    {field.name === 'data_correctness_confirmation' && (<label htmlFor={field.name} className="block mb-2 label-m">
                            {t('financing.solvency_declaration.confirmation_label')}
                        </label>)}
                    <Checkbox className="items-start" id={field.name} {...registerProps} label={label} onChange={handleChange}/>
                </>);
        }
        case 'select-multiple':
            return (<SelectMultipleField name={field.name} label={field.label} options={parsedValues === null || parsedValues === void 0 ? void 0 : parsedValues.map(({ value, label: optionLabel }) => ({
                    value,
                    label: optionLabel,
                }))} onChange={handleChange}/>);
        case 'text': {
            return (<div>
                    <Input className="w-full" id={field.name} {...registerProps} label={label} onChange={handleChange} isError={!!form.formState.errors[field.name]}/>
                </div>);
        }
        case 'decimal': {
            return (<div>
                    <Input className="w-full" id={field.name} type="number" step="any" {...registerProps} label={label} min={0} onKeyDown={preventNegativeNumberKeyDown} onChange={handleChange} isError={!!form.formState.errors[field.name]}/>
                    <FormTooltip name={field.name}/>
                </div>);
        }
        case 'int': {
            return (<div>
                    <Input className="w-full" id={field.name} type="number" min={0} {...registerProps} label={label} onKeyDown={preventNegativeNumberKeyDown} onChange={handleChange} isError={!!form.formState.errors[field.name]}/>
                    <FormTooltip name={field.name}/>
                </div>);
        }
        case 'group':
            return null;
        default:
            return null;
    }
};
